/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import EffectSequence from '../../../Effects/EffectSequence';
import ComponentBase from '../../ComponentBase';
import SelectListViewModel from '../UI/SelectListViewModel';
import AnimationButton from './AnimationButton';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default class AnimationRunner extends cc.Component
{
    @property(SelectListViewModel)
    protected selectedListVM: SelectListViewModel<EffectSequence> = null;

    @property(AnimationButton)
    protected animationButton: AnimationButton = null;

    @property(cc.Button)
    protected toggleButton: cc.Button = null;

    private _effectSequences: EffectSequence[] = [];

    protected onLoad(): void
    {
        this.animationButton.node.on(cc.Node.EventType.TOUCH_END,
            (event) => this.toggleButton.node.dispatchEvent(event));

        this.animationButton.node.on(AnimationButton.OnCompleteEventName,
            () =>
            {
                if (!this.selectedListVM.node.active)
                {
                    this.toggleButton.node.emit(cc.Node.EventType.TOUCH_END);
                }
            });

        this.configureToggleButton();
    }

    private configureToggleButton(): void
    {
        if (!this.toggleButton) { return; }

        this.toggleButton.node.on(cc.Node.EventType.TOUCH_START, ComponentBase.CancelEventHandler);
        this.toggleButton.node.on(cc.Node.EventType.TOUCH_END,
            (event: cc.Event.EventCustom) =>
            {
                let newValue: boolean = !this.selectedListVM.node.active;

                if (newValue)
                {
                    this.toggleButton.getComponentInChildren(cc.Label).string = '-';
                    this.node.y = this.node.y - this.selectedListVM.node.height / 2.0;
                    this.selectedListVM.node.active = true;
                }
                else
                {
                    this.toggleButton.getComponentInChildren(cc.Label).string = '+';
                    this.node.y = this.node.y + this.selectedListVM.node.height / 2.0;
                }

                this.selectedListVM.node.active = newValue;
            });
    }

    /** @hidden */
    protected start(): void
    {
        let count: number = 0;
        this._effectSequences = cc.director.getScene().getComponentsInChildren(EffectSequence);

        for (let effectSequence of this._effectSequences)
        {
            this.selectedListVM.Add(
            {
                ItemId: count.toString(),
                Item: effectSequence,
                DisplayName: `${effectSequence.node.parent.name}/${effectSequence.node.name}`
            });
            count++;
        }

        this.selectedListVM.OnSelectedIndexChanged(() => this.updateButton());
        this.selectedListVM.ForceUpdate();
    }

    private updateButton(): void
    {
        this.animationButton.EffectSequence = this.selectedListVM.Selected.Item;
    }
}
